import React from 'react';

interface ElevatedButtonProps {
  title: string;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
  disabled?: boolean;
}

const ElevatedButton: React.FC<ElevatedButtonProps> = ({
  title,
  onClick,
  className,
  disabled = false,
}) => {
  return (
    <button
      disabled={disabled}
      className={`inline-flex justify-center w-full rounded-md border border-primary px-4 py-2 bg-primary text-sm leading-5 font-medium text-on-primary hover:text-on-primary/80 focus:outline-none focus:border-primary focus:shadow-outline-primary  transition ease-in-out duration-150 ${className}`}
      onClick={onClick}
    >
      {title}
    </button>
  );
};

export default ElevatedButton;
